import { MenuItem } from '@mui/material';
import React from 'react';

interface HeaderDropdownMenuItemProps {
	cy: string;
	_id: string;
	name?: string;
	children: JSX.Element[] | JSX.Element | string;
	switchAction: (id: string) => void;
	closeMenu: () => void;
}

export default function HeaderDropdownMenuItem({
	_id,
	cy,
	name,
	switchAction,
	closeMenu,
	children,
}: HeaderDropdownMenuItemProps): JSX.Element {
	return (
		<MenuItem
			data-cy={cy}
			key={_id}
			// title={'Click to switch orgs'}
			onClick={() => {
				switchAction(_id as string);
				closeMenu();
			}}>
			{children}
		</MenuItem>
	);
}
